export const links = {
  etl: "https://res.cloudinary.com/df3ajcohw/image/upload/v1632079785/assets/xcfnjixti2tsa2utqwxu.png",
  ul: "https://res.cloudinary.com/df3ajcohw/image/upload/v1632080269/assets/dwioz6njc6mmqirakp1n.png",
  ite: "https://res.cloudinary.com/df3ajcohw/image/upload/v1666157631/assets/ohnpivgrhutpcbidcdl0.png",
  dlc: "https://res.cloudinary.com/df3ajcohw/image/upload/v1691603045/assets/lsohztwyxgobvbtukh83.png",
};
